import React, { Fragment } from 'react';
import { GQLParty } from '@jewelutions/core-crm-server-api-client-domain';

interface IProps {
  party: GQLParty;
}

const PartyDetails: React.FC<IProps> = ({ party }: IProps) => {
  return <Fragment>TBD </Fragment>;
};

export default PartyDetails;
